<template>
    <div id="content" class="alerts" :class="[$mq, 'multiple-alerts']">
        <AlertBox :title="'sensor.alerts_tool.title'" :description="'sensor.alerts_tool.description'" :num_alerts="sensorAlerts" :link="'sensor'" :linkText="'sensor.alerts_tool.linkText'" :status="'issues'"></AlertBox>
        <AlertBox :title="'sensor.alerts_tool.alert.title'" :description="'sensor.alerts_tool.alert.description'" :num_alerts="sensorOnAlert" :link="'sensor'" :linkText="'sensor.alerts_tool.inactive.linkText'" :status="'alerts'"></AlertBox>
        <AlertBox :title="'sensor.alerts_tool.turned_off.title'" :description="'sensor.alerts_tool.turned_off.description'" :num_alerts="sensorTurnedOff" :link="'sensor'" :linkText="'sensor.alerts_tool.inactive.linkText'" :status="'turned-off'"></AlertBox>
        <AlertBox :title="'sensor.alerts_tool.inactive.title'" :description="'sensor.alerts_tool.inactive.description'" :num_alerts="sensorInactive" :link="'sensor'" :linkText="'sensor.alerts_tool.inactive.linkText'" :status="'inactive'"></AlertBox>
    </div>
</template>

<script>
import AlertBox from '@/components/layout/AlertBox'

export default {
    name: 'Alerts',
    components: { AlertBox },
    data() {
        return { }
    },
    computed: {
        sensorAlerts(){
            let alerts = this.$store.getters.getAlertsActive
            let sensorAlerts = alerts.sensor

            return sensorAlerts
        },
        sensorHome() {
            return this.$store.getters['sensor/getSensorHome'];
        },
        sensorOnAlert() {
            return this.sensorHome.alerts
        },
        sensorInactive(){
            return this.sensorHome.inactive
        },
        sensorTurnedOff(){
            return this.sensorHome.turned_off;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.alerts {
    > .content {
        @include display-flex();
        @include align-items(flex-start);
        @include justify-content(center);
        background-color: transparent;
        height: 100% !important;
        padding-bottom: 0 !important;
        &.full {
            width: 100% !important;
        }
        .col {
            height: calc(100%);

            .date {
                padding-top: 10px;
            }

            .section {
                display: block;
                width: 100%;
                height: auto;
                padding: 6px 0;
                overflow: auto;
            }

            &.notes {
                height: calc(100%);
                width: 100%;
                overflow: auto;
                padding: 10px 10px 0 10px;
                position: relative;
                display: flex;
                align-items: flex-start;
                flex-direction: column;

                > .empty {
                    margin-top: 60px;
                    padding-top: 85px;
                }

                .separator {
                    @include display-flex();
                    @include justify-content();
                    position: relative;
                    text-align: center;

                    .caption {
                        @include font-size(xs);
                        @include background($color: $neutro);
                        @include border-radius(4px);
                        padding: 6px;
                        font-family: $conden-bold;
                        color: $main-s10;
                        z-index: 1;
                        text-transform: uppercase;
                    }
                    &:before {
                        content: '';
                        position: absolute;
                        top: 50%;
                        left: 0;
                        border-top: 1px solid $inactive;
                        background: $inactive;
                        width: 100%;
                        transform: translateY(-50%);
                    }
                }

                .list-notes {
                    height: calc(100% - 80px);
                    padding: 0px 12px 12px 12px;
                    width: 100%;
                    position: relative;

                    &.with-trial {
                        max-height: calc(100% - 70px - 12px - 100px);
                    }

                    &.editing-img {
                        height: calc(100% - 205px);
                    }
                    &.editing {
                        height: calc(100% - 130px);
                    }
                }
            }
        }
        .noConnectionBox {
            width: 100%;
        }
    }
    &.multiple-alerts {
        display: grid;
        grid-template-columns: repeat(2, auto);
        grid-template-rows: repeat(2, auto);
        gap: 15px;
        align-items: center;
        justify-items: center;
        justify-content: center;
        align-content: center;
        padding: 0;
        //height: 100%;
        //min-height: 100vh;
        //width: fit-content;
        //max-width: 100%;
        margin: 0 auto;
    }
}
</style>

// PORTRAIT STYLES
<style lang="scss" scoped>
.portrait {
    background-color: $default-bg-color;
    height: auto;
    
    &.multiple-alerts {
        grid-template-columns: repeat(1, auto);
        grid-template-rows: repeat(4, auto);
        gap: 12px;
        min-height: calc(100vh - 90px);
        padding-top: 16px;
        padding-bottom: 16px;
        padding-left: 8px;
        padding-right: 8px;
        justify-content: center;
        align-content: flex-start;
        box-sizing: border-box;
    }
    
    .content .noConnectionBox {
        display: flex;
        justify-content: center;
    }

    .content.full {
        display: block;
        width: 100%;

        .col {
            &.notes {
                max-width: 100%;
                width: 100%;
                height: auto;
                position: unset;
                display: block;
                height: calc(100vh - 90px);
                padding: 0;

                .list-notes {
                    // padding: 0 10px;
                    padding: 0;
                    height: calc(100% - 80px);
                    // overflow-y: hidden;

                    &::-webkit-scrollbar {
                        display: none;
                    }

                    &.with-trial {
                        max-height: calc(100% - 70px - 12px - 190px);
                    }
                    &.editing {
                        height: calc(100% - 110px);
                    }
                }
            }
        }

        .noConnection {
            width: 200px;
            height: 200px;
        }
    }
}
</style>
